import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import AppCell from '@/components/common/app-cell';
import ScrollSelector from '@/components/common/ScrollSelector';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LanguageSelect from '@/components/mine/language-select';
import useUserPlatform from '@/hooks/use-user-platform';
import { supportedLanguages } from '@/i18n';
import ROUTES from '@/routes';
import { useLayoutStore } from '@/stores/layout-status';

export default function GeneralSettingsIndexRoute() {
  const [showLang, setShowLang] = useState(false);
  const [showDisplay, setShowDisplay] = useState(false);
  const { t, i18n } = useTranslation();
  const { isEmbedded } = useUserPlatform();
  const { isDesktop, setIsDesktop } = useLayoutStore();

  return (
    <PageLayout
      blockOnDesktop
      title={t('mine.general')}
      headerConfig={{
        navigateBack: true,
      }}>
      <div className='mx-1 flex flex-col'>
        {!isEmbedded && (
          <AppCell
            label={t('general-settings.language')}
            content={
              supportedLanguages.find(({ value }) => i18n.resolvedLanguage === value)?.label ??
              t('general-settings.system-language')
            }
            chevron
            onClick={() => setShowLang(true)}
          />
        )}

        {!isEmbedded && (
          <AppCell
            label={t('general-settings.display-mode.title')}
            content={isDesktop ? t('general-settings.display-mode.desktop') : t('general-settings.display-mode.mobile')}
            chevron
            onClick={() => setShowDisplay(true)}
          />
        )}

        <Link to={ROUTES.MY.SETTINGS.GENERAL.FEEDBACK.$path()}>
          <AppCell
            label={t('general-settings.feedback')}
            chevron
          />
        </Link>

        {!isEmbedded && (
          <Link to={ROUTES.MY.SETTINGS.GENERAL.ABOUT_US.$path()}>
            <AppCell
              label={t('general-settings.about-us')}
              chevron
            />
          </Link>
        )}

        <Link to={ROUTES.MY.SETTINGS.GENERAL.DEBUG.$path()}>
          <AppCell
            label={t('general-settings.debug.title')}
            chevron
          />
        </Link>
      </div>

      {!isEmbedded && (
        <LanguageSelect
          show={showLang}
          onClose={() => setShowLang(false)}
        />
      )}

      {!isEmbedded && (
        <ScrollSelector
          show={showDisplay}
          onCancel={() => setShowDisplay(false)}
          onConfirm={(value) => {
            setIsDesktop(value === 'desktop');
            setShowDisplay(false);
          }}
          title={t('general-settings.display-mode.title')}
          defaultValue={isDesktop ? 'desktop' : 'mobile'}
          items={['desktop', 'mobile'].map((value) => ({
            key: value,
            label: t(`general-settings.display-mode.${value}`),
            value,
          }))}
        />
      )}
    </PageLayout>
  );
}
